<template>
  <div>
    <transition name="modal-fade">
      <div
        v-if="items.length > 0 && currentImage"
        class="project-images-modal"
      >
        <div
          class="project-images-modal__backdrop"
          @click="closeModal"
        />
        <div class="project-images-modal__content">
          <div class="project-images-modal__active">
            <i
              class="project-images-modal__close icon ion-android-close"
              @click="closeModal"
            />
            <iframe
              class="project-images-modal__iframe"
              :src="currentImage.embed"
              frameborder="0"
              v-if="currentImage.embed"
            />
            <img
              :src="currentImage.picture.originalUrl"
              v-else
            >
          </div>
          <div
            class="project-images-modal__images"
            v-if="items.length > 1"
          >
            <div
              :class="['project-images-modal__image', {'project-images-modal__image--active': index === activeImage}]"
              v-for="(image, index) in items"
              :key="image.id"
              @click="setActiveImage(index)"
            >
              <img
                :src="image.picture.mediumUrl"
                v-if="image.picture"
              >
              <img
                :src="image.image"
                v-else-if="image.image"
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      default() {
        return [];
      },
    },
    initialItem: Number,
  },
  data() {
    return {
      activeImage: 0,
    };
  },
  mounted() {
    this.activeImage = this.initialItem;
  },
  computed: {
    currentImage() {
      return this.items[this.activeImage];
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    setActiveImage(index) {
      this.activeImage = index;
    },
  },
};
</script>

<style lang="scss">

</style>
